<lms-breadcrumb [crumbs]="[{ label: 'settings.clients.title', icon: 'glicon-clients', route: '.' }]"></lms-breadcrumb>

<mat-tab-group class="tab-group" #tabGroup animationDuration="0ms" disableRipple="true">
  <mat-tab *lmsProfileGuard="'settings.clients_dashboard'" label="dashboard">
    <ng-template mat-tab-label>
      <div data-testid="settingsClientsDashboardTab">{{ 'nouns.dashboard' | translate }}</div>
    </ng-template>
    <ng-template matTabContent>
      <div class="cards__single margin-top">
        <div class="cards__subtitle">
          {{ 'settings.clients.activationWidget.title' | translate }}
        </div>
        <lms-clients-activation-widget></lms-clients-activation-widget>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
